import {alpha} from '@mui/material';

const WHITE = '#FFFFFF';

export const glassWhite = {
  0: alpha(WHITE, 0),
  2: alpha(WHITE, 0.02),
  5: alpha(WHITE, 0.05),
  10: alpha(WHITE, 0.1),
  20: alpha(WHITE, 0.2),
  30: alpha(WHITE, 0.3),
  40: alpha(WHITE, 0.4),
  50: alpha(WHITE, 0.5),
  60: alpha(WHITE, 0.6),
  70: alpha(WHITE, 0.7),
  80: alpha(WHITE, 0.8),
  90: alpha(WHITE, 0.9),
} as const;
